import type { Styles } from '@adornis/ass/style.js';
import { A } from '@adornis/base/env-info.js';
import { XDragDrop } from '@adornis/dragdrop/x-drag-drop.js';
import type { ChancenwerkUser } from '@chancenwerk/shared/master-data-management/users/entities/ChancenwerkUser.js';
import { Student } from '@chancenwerk/shared/master-data-management/users/entities/Student.js';
import { StudentType } from '@chancenwerk/enums/enums.js';
import { customElement, property } from 'lit/decorators.js';
/**
 * @customElement board-component-drag-drop
 */
@customElement('board-component-drag-drop')
export class BoardComponentDragDrop extends XDragDrop {
  public _id = A.getGloballyUniqueID();

  @property({ attribute: false }) showDroppableIndicator = false;
  @property({ attribute: false }) isDroppable = false;
  @property({ attribute: true }) private readonly type: 'US' | 'OS' = 'US';

  override styles = () => [
    ...super.styles(),
    {
      ':host': {
        background: !this.showDroppableIndicator
          ? this.colors.neutral.shade(100)
          : this.isDroppable
            ? this.colors.primary.shade(200)
            : this.colors.tone.error.shade(200),
        borderRadius: '15px',
        'touch-action': 'none',
      },
    } satisfies Styles,
  ];

  public resetIndicator() {
    this.showDroppableIndicator = false;
  }

  public showIndicator() {
    this.showDroppableIndicator = true;
  }

  public setIsDroppable(user: ChancenwerkUser) {
    if (user._class === Student._class) {
      const schüler = user as Student;
      if (this.type === 'OS' && schüler.schuelertyp === StudentType.OS) this.isDroppable = true;
      if (this.type === 'US' && schüler.schuelertyp === StudentType.US) this.isDroppable = true;
    }

    this.isDroppable = false;
  }
}
